import React, {Component} from 'react';
import axios from "axios";
import Button from "react-bootstrap/Button";

import classes from "./NewPatternConstraint.module.css"
import Form from "react-bootstrap/Form";
import apiUrl from "../../../shared/config";
import SubmitButtonWarning from "../../UI/SubmitButtonWarning/SubmitButtonWarning";

class NewPatternConstraint extends Component  {
    state = {
        pattern_constraints: [],
        pattern_constraint: {
            constraint_id: null,
            constraint_title: '',
            constraint_description: ''
        },
        showFailMessage: false,
        failMessage: ''
    };

    componentDidMount() {
        if (this.props.pattern_constraints !== []) {
            this.setState({pattern_constraints: this.props.pattern_constraints});
        }
    }

    addHandler = () => {
        this.postDataHandler(null);
    };

    postDataHandler = () => {
        const post = {
            constraint_id: this.state.pattern_constraint.constraint_id,
            constraint_title: this.state.pattern_constraint.constraint_title,
            constraint_description: this.state.pattern_constraint.constraint_description,
        };
        axios.post(apiUrl +'PatternConstraints/setPatternConstraint?token=' + this.props.token, post)
            .then(response => {
                if (!response.data.message) {
                    this.props.onNewPatternConstraint(response.data);
                    this.setState({
                        pattern_constraint: {
                            constraint_id: null,
                            constraint_title: '',
                            constraint_description: ''
                        }
                    });
                    this.props.newPatternConstraintToggle();
                } else {
                    console.log(response.data.message)
                    this.setState({
                        showFailMessage: true,
                        failMessage: response.data.message
                    });
                }
            });


    };

    render() {
        return (
            <>
                <dd className={"col-sm-9"}>
                    <div className={classes.NewPatternConstraintsBlock}>
                        <div>
                            <Form.Control
                                type="text"
                                style={{marginBottom: 5}}
                                placeholder="Enter the name of the constraint you want to create."
                                value={this.state.pattern_constraint.constraint_title}
                                onChange={(event) => this.setState({pattern_constraint: {...this.state.pattern_constraint, constraint_title: event.target.value}})}
                            />
                            <Form.Control
                                as="textarea"
                                rows="4"
                                placeholder="Include a paragraph or so long description of the constraint."
                                value={this.state.pattern_constraint.constraint_description}
                                onChange={(event) => this.setState({pattern_constraint: {...this.state.pattern_constraint, constraint_description: event.target.value}})}
                            />
                        </div>
                        <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newPatternConstraintToggle}>Cancel</Button>
                        <SubmitButtonWarning
                            token={this.props.token} userId={this.props.userId}
                            handleSubmit={this.addHandler}
                            failMessage={this.state.failMessage}
                            setShowFailMessage={(show) => this.setState({showFailMessage: show})}
                            showFailMessage={this.state.showFailMessage}
                            postType={{
                                lowercase: "pattern constraint",
                                capital: "Pattern Constraint",
                                capitalLowercase: "Pattern constraint",
                            }}
                            submitButton={
                                <Button className="col-sm-3" variant="outline-primary" onClick={
                                    this.addHandler
                                }>Submit</Button>
                            }
                        />
                    </div>
                </dd>
                <dt className="col-sm-3"> </dt>
            </>
        );
    }
}

export default NewPatternConstraint;